<!-- Interactive: native radio group; stars stay on labels so look is unchanged -->
@if (!readOnly) {
  <div
    role="radiogroup"
    class="flex items-center justify-center"
    [attr.aria-labelledby]="ariaLabelledBy || null"
    (mouseleave)="onStarGroupLeave()"
    >
    @for (index of starIndexes; track index) {
      <div class="inline-flex leading-none">
        <input
          type="radio"
          class="sr-only peer"
          [id]="radioIdPrefix + index"
          [name]="radioGroupName"
          [value]="index"
          [checked]="isRadioChecked(index)"
          [attr.aria-label]="starOptionAriaLabel(index)"
          (change)="setRating(index)"
          />
          <label
            [for]="radioIdPrefix + index"
            class="text-gray-600 text-2xl cursor-pointer m-0 peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-primary rounded-sm"
            (mouseenter)="onStarHover(index)"
            >
            <ng-icon
              [name]="isStarFilled(index) ? 'star' : 'star-outline'"
              class="text-gray-600 text-2xl"
        [ngClass]="{
          '!text-green': isStarFilled(index)
        }"
              />
            </label>
          </div>
        }
      </div>
    }

    <!-- Read-only: decorative stars + single summary for assistive tech -->
    @if (readOnly) {
      <div
        class="flex items-center justify-center"
        [attr.role]="readOnlyAriaLabel ? 'img' : null"
        [attr.aria-label]="readOnlyAriaLabel || null"
        [attr.aria-hidden]="readOnlyAriaLabel ? null : 'true'"
        >
        @for (index of starIndexes; track index) {
          <div aria-hidden="true" class="inline-flex leading-none">
            <ng-icon
              [name]="isStarFilled(index) ? 'star' : 'star-outline'"
              class="text-gray-600 text-2xl"
      [ngClass]="{
        '!text-green': isStarFilled(index)
      }"
              />
            </div>
          }
        </div>
      }
